// Configure Turbo
import * as Turbo from "@hotwired/turbo-rails"

// Import all Stimulus controllers
import "./controllers"
